const createClusterContent = (count) => {
    const div = document.createElement('div');
    div.style.backgroundColor = 'red';
    div.style.border = '2px solid white';
    div.style.borderRadius = '50%';
    div.style.width = '40px';
    div.style.height = '40px';
    div.style.display = 'flex';
    div.style.alignItems = 'center';
    div.style.justifyContent = 'center';
    div.style.color = 'white';
    div.style.fontSize = '14px';
    div.innerText = count;
    return div;
}

const batchAddMarkers = (clusterer, markers, batchSize = 50, delay = 0) => {
    let index = 0;

    const processBatch = () => {
        if (index >= markers.length) return;

        const nextBatch = markers.slice(index, index + batchSize);
        clusterer.addMarkers(nextBatch);

        index += batchSize;
        setTimeout(processBatch, delay);
    };

    processBatch();
};

const buildMarkers = async (map) => {
    if (!map || findExerciseLocationMap.markers.length > 0) return;

    const markersData = await fetchMarkers();

    // (NOTE) -- this could, and should be improved to view an UI message where Users are informed that the Markers was not properly loaded & possibly let them try to refetch. --
    if (!markersData) return;

    const newMarkers = [];
    if (!Array.isArray(markersData.markers)) throw new Error("Invalid marker data structure");

    markersData.markers.forEach(markerItem => {
        try {
            if (!markerItem.longitude || !markerItem.latitude) return;

            const marker = new google.maps.marker.AdvancedMarkerElement({
                map: findExerciseLocationMap.map,
                position: new google.maps.LatLng(Number(markerItem.latitude.trim()), Number(markerItem.longitude.trim())),
                title: markerItem.name ?? '',
                gmpClickable: true,
            });

            marker.content = buildMarkersContent(markerItem, map.dataset.markerbtntext, map.dataset.markerclosetext, marker);

            findExerciseLocationMap.markers.push(marker);
            newMarkers.push(marker);

            marker.addEventListener("gmp-click", () => toggleHighlight(marker));
            marker.addEventListener("gmp-touch", () => toggleHighlight(marker));

        } catch (error) {
            console.warn(`Failed to create marker for ${markerItem?.name || 'unknown'}:`, error);
        }
    });

    // Add only the new markers to the cluster
    if (findExerciseLocationMap?.clusterArray && newMarkers.length > 0) {
        batchAddMarkers(findExerciseLocationMap.clusterArray, newMarkers, 50, 10);
    }
};

const buildMarkersContent = (markerItem, markerbtntext, markerclosetext, marker) => {
    const content = document.createElement("div");
    content.setAttribute("data-city-id", markerItem.cityId);
    content.setAttribute("data-city", markerItem.cityName);
    content.setAttribute("data-facility", markerItem.name);
    content.setAttribute("data-lat", markerItem.latitude);
    content.setAttribute("data-lng", markerItem.longitude);
    content.setAttribute("data-workouttypes", JSON.stringify(markerItem.workoutList));
    content.setAttribute("data-conveniences", JSON.stringify(markerItem.conveniences));
    content.classList.add("gyms-marker");

    // Create the icon div
    const iconDiv = document.createElement("div");
    iconDiv.classList.add("icon");

    // Create the img element
    const img = document.createElement("img");
    img.tabIndex = -1;
    img.classList.add("h-full", "w-full", "object-cover", "rounded-full");
    img.src = "data:image/png;base64,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";
    img.alt = "logotyp";

    iconDiv.appendChild(img);

    // Create the details div
    const detailsDiv = document.createElement("div");
    detailsDiv.classList.add("details", "flex-col", "gap-y-4");
    const detailsButtons = document.createElement("div");
    detailsButtons.classList.add("details", "flex-col", "gap-y-2");

    // Create the first inner div
    const innerDiv1 = document.createElement("div");
    innerDiv1.classList.add("flex", "flex-col", "gap-y-1");

    // Create the h3 element
    const h3 = document.createElement("h3");
    h3.classList.add("text-heading-2-md", "text-solid-black");
    h3.textContent = markerItem.name;

    // Create the small element
    const small = document.createElement("small");
    small.classList.add("text-caption-lg", "text-text-subtle");
    small.textContent = markerItem.address;

    innerDiv1.appendChild(h3);
    innerDiv1.appendChild(small);

    const link = document.createElement("a");
    link.classList.add("btn-primary", "h-6");
    link.textContent = markerbtntext;
    link.setAttribute('aria-label', `Link to ${markerItem.name}`);
    link.setAttribute("href", `${markerItem.url}`)
    link.addEventListener("gmp-click", (event) => {
        event.stopPropagation();
    });

    // Ensure touch support
    link.addEventListener("touchend", (event) => {
        event.stopPropagation();
        window.location.href = markerItem.url;
    });

    const close = document.createElement("button");
    close.classList.add("btn-outlined", "h-6", "rounded-full");
    close.textContent = markerclosetext ?? "St�ngsda";
    close.setAttribute('aria-label', "Close");
    close.addEventListener("gmp-click", (event) => {
        event.stopPropagation();
        toggleHighlight(marker)
    });
    // Ensure touch support
    close.addEventListener("touchend", (event) => {
        event.stopPropagation();
        toggleHighlight(marker)
    });


    detailsButtons.appendChild(link);
    detailsButtons.appendChild(close);
    detailsDiv.appendChild(innerDiv1);
    detailsDiv.appendChild(detailsButtons);
    content.appendChild(iconDiv);
    content.appendChild(detailsDiv);

    return content;
}

const toggleHighlight = (markerView) => {
    if (markerView.content.classList.contains("highlight")) {
        markerView.content.classList.remove("highlight");
        markerView.zIndex = null;
    } else {
        markerView.content.classList.add("highlight");
        markerView.zIndex = 1001000;
    }
}

const hideMarkers = (markersToFocus) => {
    findExerciseLocationMap.markers.forEach(marker => {
        // Display markers in focus, hide others
        marker.element.style.display = markersToFocus.includes(marker) ? "block" : "none";
    });

    // Filter visible markers and update clusterer
    const visibleMarkers = findExerciseLocationMap.markers.filter(marker => marker.element.style.display !== "none");
    handleClusterer(visibleMarkers);
}

const showAllMarkers = () => {
    if (findExerciseLocationMap.markers) {
        // Display all markers
        findExerciseLocationMap.markers.forEach(marker => {
            marker.element.style.display = "block";
        });
    }

    // Filter visible markers and update clusterer
    const visibleMarkers = findExerciseLocationMap.markers.filter(marker => marker.element.style.display !== "none");
    handleClusterer(visibleMarkers);
}

const handleClusterer = (visibleMarkers) => {
    if (findExerciseLocationMap.clusterArray) {
        // Clear existing markers and add the new visible markers
        findExerciseLocationMap.clusterArray.clearMarkers();
        findExerciseLocationMap.clusterArray.addMarkers(visibleMarkers);
    }
}
